import { useCallback, useState } from "react";

export type DashboardView = "overview" | "table" | "calendar" | "finance";

const STORAGE_KEY = "dashboardView.v1";
const VIEWS: DashboardView[] = ["overview", "table", "calendar", "finance"];

/** Overview is the default; a view picked before stays remembered per browser. */
const read = (): DashboardView => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY) as DashboardView | null;
    return stored && VIEWS.includes(stored) ? stored : "overview";
  } catch {
    return "overview";
  }
};

/** Dashboard presentation, remembered per browser; the screen enforces Finance access. */
export function useDashboardView(): [
  DashboardView,
  (next: DashboardView) => void,
] {
  const [view, setViewState] = useState<DashboardView>(read);
  const setView = useCallback((next: DashboardView) => {
    setViewState(next);
    try {
      localStorage.setItem(STORAGE_KEY, next);
    } catch {
      /* ignore */
    }
  }, []);
  return [view, setView];
}
